import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import ScrollToTop from "@/components/ScrollToTop";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingActions from "@/components/FloatingActions";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Industries from "@/pages/Industries";
import Infrastructure from "@/pages/Infrastructure";
import NetworkPage from "@/pages/Network";
import Clients from "@/pages/Clients";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import NotFound from "@/pages/NotFound";

function Shell() {
    const { pathname } = useLocation();
    const isAdmin = pathname.startsWith("/admin");
    return (
        <>
            <ScrollToTop />
            {!isAdmin && <Header />}
            <main data-testid="main-content">
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/industries" element={<Industries />} />
                    <Route path="/infrastructure" element={<Infrastructure />} />
                    <Route path="/network" element={<NetworkPage />} />
                    <Route path="/clients" element={<Clients />} />
                    <Route path="/careers" element={<Careers />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/admin" element={<AdminLogin />} />
                    <Route path="/admin/dashboard" element={<AdminDashboard />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </main>
            {!isAdmin && <Footer />}
            {!isAdmin && <FloatingActions />}
        </>
    );
}

function App() {
    return (
        <div className="App" data-testid="app-root">
            <BrowserRouter>
                <Shell />
                <Toaster
                    position="bottom-center"
                    toastOptions={{
                        style: {
                            borderRadius: 0,
                            border: "1px solid #28406A",
                            background: "#101A2C",
                            color: "#FFFFFF",
                            fontFamily: "IBM Plex Sans, sans-serif",
                        },
                    }}
                />
            </BrowserRouter>
        </div>
    );
}

export default App;
